function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.498 2.95h12.299c1.112 0 2.021.936 2.021 2.079v12.467c0 .052-.01.104-.02.166l-3.416-3.511c.243-.198.404-.478.404-.81V12.3H16.27v.52H16.1l-1.85-1.902V9.704h2.021v.52h1.516v-1.04c0-.571-.455-1.039-1.01-1.039h-3.032c-.556 0-1.01.468-1.01 1.04v.176l-6.236-6.41zm13.087 19.336l-2.638-2.712H4.648c-1.121 0-2.02-.935-2.02-2.078V5.03c0-.052.02-.104.02-.156L1 3.179l1.425-1.465L21 20.81l-1.415 1.476zm-8.873-9.122l-.839-.863h-.677v.52H7.175V9.704h.172l-1.284-1.33a1.038 1.038 0 00-.404.81v4.156c0 .572.455 1.04 1.01 1.04h3.032c.556 0 1.011-.468 1.011-1.04v-.176z"
});

function SvgClosedCaptionOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedCaptionOff);
export default __webpack_public_path__ + "static/media/closedCaption-off.08bb3d16.svg";
export { ForwardRef as ReactComponent };